import { siteConfig } from '../config/siteConfig';

// Function to set CSS variables from siteConfig
export const setCSSVariables = () => {
  const root = document.documentElement;
  const { colors, typography } = siteConfig;
  
  // Set color variables
  root.style.setProperty('--color-primary', colors.primary);
  root.style.setProperty('--color-primary-dark', colors.primaryDark);
  root.style.setProperty('--color-secondary', colors.secondary);
  root.style.setProperty('--color-white', colors.white);
  root.style.setProperty('--color-black', colors.black);
  root.style.setProperty('--color-background', colors.background);
  root.style.setProperty('--color-text-primary', colors.text.primary);
  root.style.setProperty('--color-text-secondary', colors.text.secondary);
  root.style.setProperty('--color-text-dark', colors.text.dark);
  
  // Set typography variables
  root.style.setProperty('--font-family-primary', typography.fontFamily.primary);
  root.style.setProperty('--font-family-scrolling', typography.fontFamily.scrolling);
  root.style.setProperty('--font-family-footer', typography.fontFamily.footer);
  root.style.setProperty('--font-family-fallback', typography.fontFamily.fallback);
};

// Initialize CSS variables when module loads
export const initializeCSSVariables = () => {
  // Set variables immediately
  setCSSVariables();
  
  // Set variables when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setCSSVariables);
  }
}; 